import React, { useState, useEffect, useRef } from 'react';
import CommonModalForm from '../../components/commonComponent/CommonModalForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import axios from '../../utils/axiosInstance';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const ChapterPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const clusterId = params.get('clusterId');
  const [chapter, setChapter] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({
    prefix: '',
    name: '',
    shortName: '',
    type: '',
    city: '',
    fees: '',
    cluster: clusterId,
  });
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Dropdowns
  const [cityOptions, setCityOptions] = useState([]);
  const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10);
  const isEditingRef = useRef(false);

  // Fetch all cities on mount
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await axios.get('/admin/api/city');
        setCityOptions(res.data?.cities?.map(c => ({ value: c._id, label: c.name })) || []);
      } catch (err) {
        toastError('Failed to fetch cities');
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    fetchChapter(currentPage, searchQuery, clusterId);
  }, [currentPage, searchQuery, clusterId]);

  const fetchChapter = async (page = 1, search = '', clusterId = '') => {
    const safeClusterId = clusterId ?? '';  
    try {
      const res = await axios.get(`/admin/api/chapters/all?page=${page}&limit=${limit}&search=${search}&clusterId=${safeClusterId}`);
      const { chapter = [], totalCount = 0 } = res.data;
      setChapter(chapter);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      console.error('Failed to fetch Chapter:', err);
    }
  };

  const handleSave = async () => {
    const validationErrors = validateForm(formValues, {
      name: { required: true },
      prefix: { required: true },
    });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      if (editingId) {
        await axios.put(`/admin/api/chapters/${editingId}`, formValues);
        toastSuccess('Chapter updated successfully!');
      } else {
        await axios.post('/admin/api/chapters', formValues);
        toastSuccess('Chapter added successfully!');
      }
      setCurrentPage(1);
      fetchChapter(1, searchQuery);
      handleCancel();
    } catch (err) {
      console.error('Failed to save Chapter:', err);
      toastError('Failed to save Chapter');
    }
  };

  // Edit chapter
  const handleEdit = async (chapterData) => {
    isEditingRef.current = true;
    setEditingId(chapterData._id);

    setFormValues({
      prefix: chapterData.prefix || '',
      name: chapterData.name || '',
      shortName: chapterData.shortName || '',
      type: chapterData.type || '',
      city: chapterData.city || '',
      fees: chapterData.fees || '',
    });

    setShowModal(true);
    setTimeout(() => { isEditingRef.current = false; }, 500);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/admin/api/chapters/${id}`);
      toastSuccess('Chapter deleted successfully!');
      setCurrentPage(1);
      fetchChapter(1, searchQuery);
    } catch (err) {
      console.error('Failed to delete Chapter:', err);
      toastError('Failed to delete Chapter');
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormValues({
      prefix: '',
      name: '',
      shortName: '',
      type: '',
      city: '',
      fees: '',
    });
    setEditingId(null);
    setErrors({});
    isEditingRef.current = false;
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0"> Chapter</h3>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search Chapter..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0">Chapter List</h5>
          <button
            className="btn btn-sm btn-success"
            onClick={() => setShowModal(true)}
          >
            + Add New Chapter
          </button>
        </div>

        <div className="card-body p-0">
          <table
            className="table table-bordered table-sm mb-0"
            style={{ fontSize: '14px', lineHeight: '2' }}
          >
            <thead className="table-light">
              <tr>
                <th className="py-1 px-2 w-5">Sr no.</th>
                <th className="py-1 px-2">Chapter Name</th>
                <th className="py-1 px-2">Short Name</th>
                <th className="py-1 px-2">Type</th>
                <th className="py-1 px-2">Fees</th>
                <th className="py-1 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {chapter.length > 0 ? (
                chapter.map((chapter, idx) => (
                  <tr key={chapter._id}>
                    <td className="py-1 px-2">{(currentPage - 1) * limit + idx + 1}</td>
                    <td className="py-1 px-2">{chapter.name}</td>
                    <td className="py-1 px-2">{chapter.shortName}</td>
                    <td className="py-1 px-2">{chapter.type}</td>
                    <td className="py-1 px-2">{chapter.fees}</td>
                    <td className="py-1 px-2">
                      <button
                        className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0"
                        style={{
          
                          color: '#C44C23',
                    
                        }}
                        title="Edit"
                        onClick={() => handleEdit(chapter)}
                      >
                        <FaEdit size={14} />
                      </button>
                      <button
                        className="btn btn-sm py-0 px-2 fs-6 lh-sm shadow-none border-0"
                        style={{
          
                          color: 'red',
                    
                        }}
                        title="Delete"
                        onClick={() => handleDelete(chapter._id)}
                      >
                        <FaTrash size={14} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-2">No Chapter found.</td>
                </tr>
              )}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center gap-2 p-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                &laquo;
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  className="btn btn-sm"
                  style={{
                    backgroundColor: currentPage === page ? '#C44C23' : 'transparent',
                    color: currentPage === page ? 'white' : '#C44C23',
                    border: '1px solid #C44C23'
                  }}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>

      <CommonModalForm
        visible={showModal}
        title={editingId ? 'Edit Chapter' : 'Add Chapter'}
        fields={[
          { name: 'prefix', label: 'Chapter Prefix',placeholder: 'Enter Chapter Prefix' },
          { name: 'name', label: 'Chapter', placeholder: 'Enter Chapter Name' },
          { name: 'shortName', label: 'Short Name', placeholder: 'Short Name' },
          { name: 'type', label: 'Type', type: 'select', options: [
            { value: 'Main', label: 'Main' },
            { value: 'Sub', label: 'Sub' },
            { value: 'Other', label: 'Other' },
          ], placeholder: 'Select Type' },
          { name: 'city', label: 'City', type: 'select', options: cityOptions, placeholder: 'Select City' },
          { name: 'fees', label: 'Fees', type: 'number', placeholder: 'Enter Fees Amount' },
        ]}
        values={formValues}
        errors={errors}
        onChange={setFormValues}
        onSubmit={handleSave}
        onCancel={handleCancel}
        submitLabel={editingId ? 'Update' : 'Save'}
        requiredFields={['name','prefix']}
      />
    </div>
  );
};

export default ChapterPage;